import * as actionTypes from "../actions/actionTypes";

const initialState = {
  revenues: [],
  error: false,
  loading: false,
  total: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_REVENUE:
      return {
        ...state,
        revenues: action.revenues,
        error: false,
        loading: false,
      };
    case actionTypes.SET_REVENUE_PERFORMANCE:
      return {
        ...state,
        total: action.total,
        error: false,
        loading: false,
      };
    case actionTypes.FETCH_REVENUE_FAILED:
      return {
        ...state,
        revenues: action.revenues,
        error: true,
        loading: false,
      };
    case actionTypes.FETCH_REVENUE_STARTING:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
};

export default reducer;
